import { observer } from 'mobx-react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import * as React from 'react';
import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import { computed } from 'mobx';
import getFilteredTimeFormatOptions from '../utils/getFilteredTimeFormatOptions';
import selectTimeFormatOption from '../data/mutators/selectTimeFormatOption';
import strings from 'owa-strings/owa-options-strings';
import { formatDate, utcDate } from 'owa-datetime';

let styles = require('./Regional.scss');

const EXAMPLE_START_RANGE = utcDate(2017, 8, 1, 1, 1);
const EXAMPLE_END_RANGE = utcDate(2017, 8, 1, 23, 59);

/**
 * Interface for time format selection props
 */

export interface TimeFormatSelectionProps {
    onSave?: (newTimeFormat: string) => void;
    isQuick?: boolean;
}

@observer
export default class TimeFormatSelection extends React.Component<TimeFormatSelectionProps, {}> {
    render() {
        let savedTimeFormat = getUserConfiguration().UserOptions.TimeFormat;
        let selectedKey = getRegionalOptions().selectedTimeFormat || savedTimeFormat;

        if (getFilteredTimeFormatOptions().indexOf(selectedKey) === -1) {
            selectedKey =
                getFilteredTimeFormatOptions().indexOf(savedTimeFormat) === -1
                    ? getFilteredTimeFormatOptions()[0]
                    : savedTimeFormat;
        }

        return (
            <Dropdown
                label={this.props.isQuick ? undefined : strings.option_regional_timeFormat}
                options={this.timeFormatOptions}
                selectedKey={selectedKey}
                onChanged={this.onSelectDateFormat}
                styles={{ label: styles.dropdown }}
            />
        );
    }

    private onSelectDateFormat = (item: IDropdownOption) => {
        if (this.props.onSave) {
            this.props.onSave(item.key as string);
        } else {
            selectTimeFormatOption(item.key as string);
        }
    };

    @computed
    private get timeFormatOptions() {
        return getFilteredTimeFormatOptions().map(shortTimeFormat => {
            return {
                text: `${formatDate(EXAMPLE_START_RANGE, shortTimeFormat)} - ${formatDate(
                    EXAMPLE_END_RANGE,
                    shortTimeFormat
                )}`,
                key: shortTimeFormat,
            };
        });
    }
}
